import { getCdnUrl } from "@/core/helpers/getCdnUrl";

const cdnUrl = getCdnUrl();

export default class HotelCdn {
  static getHotelImage(uuid: string, src: string) {
    return `${cdnUrl}images/interiors/${uuid}/${src}`;
  }
}
